// src/components/private/astapor/Coupons.js
// Component to show options for coupons

import React from 'react';
import CouponsList from './CouponsList';
import CouponCategory from './CouponCategory';
import AllCouponsList from './AllCouponsList';
import OptionSelector from '../common_components/OptionSelector';

const options = [
    {
        icon: "bi bi-cookie",
        label: "My Coupons",
        value: "couponsList",
        component: CouponsList
    },
    {
        icon: "bi bi-braces-asterisk",
        label: "All Coupons",
        value: "allCouponsList",
        component: AllCouponsList
    },
    {
        icon: "bi bi-tags",
        label: "Coupon Categories",
        value: "couponCategories",
        component: CouponCategory
    }
];


const CouponOptions = () => {
    return (
        <OptionSelector options={options} initialOption="couponsList" />
    )
};


export default CouponOptions;